"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _loginBg = _interopRequireDefault(require("@assets/login-bg.jpg"));
var _IcertisMarkIcon = _interopRequireDefault(require("../common/IcertisMarkIcon"));
var _BackLinkRow = _interopRequireDefault(require("./BackLinkRow"));
var _branding = require("../../utils/branding");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var ConfigureContainer = _styledComponents.styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    width: 100%;\n    background-color: white;\n    background-image: url(", ");\n    background-size: cover;\n    background-position: center;\n    overflow-y: auto;\n    padding: 8px 20px 24px;\n    box-sizing: border-box;\n"])), _loginBg.default);
var ConfigureTitle = _styledComponents.styled.h2(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: 20px;\n    font-weight: 600;\n    color: #0f172a;\n    margin: 16px 0 28px;\n"])));
var FieldLabel = _styledComponents.styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-size: 13px;\n    font-weight: 600;\n    color: #374151;\n    margin: 0 0 8px;\n"])));
var RadioPillGroup = _styledComponents.styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-bottom: 6px;\n"])));
var RadioPill = _styledComponents.styled.button(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 44px;\n    padding: 10px;\n    border-radius: 8px;\n    box-sizing: border-box;\n    border: 1.5px solid ", ";\n    background: ", ";\n    color: ", ";\n    font-size: 13px;\n    font-weight: ", ";\n    cursor: ", ";\n    text-align: left;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    opacity: ", ";\n    transition: border-color 0.1s ease;\n\n    &:hover {\n        border-color: ", ";\n    }\n"])), function (_ref) {
  var $selected = _ref.$selected;
  return $selected ? "#425BCE" : "#D1D5DB";
}, function (_ref2) {
  var $selected = _ref2.$selected;
  return $selected ? "#EEF2FF" : "white";
}, function (_ref3) {
  var $disabled = _ref3.$disabled;
  return $disabled ? "#9CA3AF" : "#0f172a";
}, function (_ref4) {
  var $selected = _ref4.$selected;
  return $selected ? "600" : "400";
}, function (_ref5) {
  var $disabled = _ref5.$disabled;
  return $disabled ? "default" : "pointer";
}, function (_ref6) {
  var $disabled = _ref6.$disabled;
  return $disabled ? 0.65 : 1;
}, function (_ref7) {
  var $disabled = _ref7.$disabled,
    $selected = _ref7.$selected;
  return $disabled ? $selected ? "#425BCE" : "#D1D5DB" : "#425BCE";
});
var RadioDot = _styledComponents.styled.span(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    border: 2px solid ", ";\n    background: ", ";\n    flex-shrink: 0;\n    position: relative;\n\n    &::after {\n        content: \"\";\n        display: ", ";\n        width: 5px;\n        height: 5px;\n        background: white;\n        border-radius: 50%;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n    }\n"])), function (_ref8) {
  var $selected = _ref8.$selected;
  return $selected ? "#425BCE" : "#9CA3AF";
}, function (_ref9) {
  var $selected = _ref9.$selected;
  return $selected ? "#425BCE" : "transparent";
}, function (_ref0) {
  var $selected = _ref0.$selected;
  return $selected ? "block" : "none";
});
var HelperText = _styledComponents.styled.p(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    font-size: 11px;\n    color: #9ca3af;\n    margin: 0 0 24px;\n    line-height: 1.4;\n"])));
var ButtonsWrapper = _styledComponents.styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 8px;\n"])));
var LoginButton = _styledComponents.styled.button(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 36px;\n    padding: 6.75px 11.25px;\n    background: #1e3a8a;\n    color: white;\n    border: none;\n    border-radius: 6.75px;\n    font-size: 15px;\n    font-weight: 600;\n    cursor: pointer;\n    box-sizing: border-box;\n    transition: background 0.15s ease;\n\n    &:hover {\n        background: #1d4ed8;\n    }\n\n    &:disabled {\n        background: #9ca3af;\n        cursor: default;\n    }\n"])));
var IcertisConfigureScreen = function IcertisConfigureScreen(_ref1) {
  var region = _ref1.region,
    setRegion = _ref1.setRegion,
    envTier = _ref1.envTier,
    setEnvTier = _ref1.setEnvTier,
    onLogin = _ref1.onLogin,
    onBack = _ref1.onBack;
  var branding = (0, _branding.getBranding)();
  var isVeraBrand = (0, _branding.getBrand)() === "vera";
  var brandMark = isVeraBrand ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
    src: branding.managedIcon,
    alt: branding.name,
    width: 28,
    height: 28
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_IcertisMarkIcon.default, {
    size: 28
  });
  var loginTitle = isVeraBrand ? "Select your Vera Engage instance to log in" : "Select your instance to log in";
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(ConfigureContainer, {
    "data-sentry-element": "ConfigureContainer",
    "data-sentry-component": "IcertisConfigureScreen",
    "data-sentry-source-file": "IcertisConfigureScreen.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_BackLinkRow.default, {
      label: "Switch Cloud",
      onClick: onBack,
      "data-sentry-element": "BackLinkRow",
      "data-sentry-source-file": "IcertisConfigureScreen.tsx"
    }), brandMark, /*#__PURE__*/(0, _jsxRuntime.jsx)(ConfigureTitle, {
      "data-sentry-element": "ConfigureTitle",
      "data-sentry-source-file": "IcertisConfigureScreen.tsx",
      children: loginTitle
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(FieldLabel, {
      "data-sentry-element": "FieldLabel",
      "data-sentry-source-file": "IcertisConfigureScreen.tsx",
      children: "Region *"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(RadioPillGroup, {
      "data-sentry-element": "RadioPillGroup",
      "data-sentry-source-file": "IcertisConfigureScreen.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(RadioPill, {
        $selected: region === "eu",
        $disabled: false,
        onClick: function onClick() {
          return setRegion("eu");
        },
        "data-sentry-element": "RadioPill",
        "data-sentry-source-file": "IcertisConfigureScreen.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(RadioDot, {
          $selected: region === "eu",
          "data-sentry-element": "RadioDot",
          "data-sentry-source-file": "IcertisConfigureScreen.tsx"
        }), "EU"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(RadioPill, {
        $selected: region === "row",
        $disabled: false,
        onClick: function onClick() {
          return setRegion("row");
        },
        "data-sentry-element": "RadioPill",
        "data-sentry-source-file": "IcertisConfigureScreen.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(RadioDot, {
          $selected: region === "row",
          "data-sentry-element": "RadioDot",
          "data-sentry-source-file": "IcertisConfigureScreen.tsx"
        }), "US"]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(HelperText, {
      "data-sentry-element": "HelperText",
      "data-sentry-source-file": "IcertisConfigureScreen.tsx",
      children: "Your region determines where your data is processed."
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(FieldLabel, {
      "data-sentry-element": "FieldLabel",
      "data-sentry-source-file": "IcertisConfigureScreen.tsx",
      children: "Environment *"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(RadioPillGroup, {
      "data-sentry-element": "RadioPillGroup",
      "data-sentry-source-file": "IcertisConfigureScreen.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(RadioPill, {
        $selected: envTier === "prod",
        $disabled: false,
        onClick: function onClick() {
          return setEnvTier("prod");
        },
        "data-sentry-element": "RadioPill",
        "data-sentry-source-file": "IcertisConfigureScreen.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(RadioDot, {
          $selected: envTier === "prod",
          "data-sentry-element": "RadioDot",
          "data-sentry-source-file": "IcertisConfigureScreen.tsx"
        }), "Production (Default)"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(RadioPill, {
        $selected: envTier === "uat",
        $disabled: false,
        onClick: function onClick() {
          return setEnvTier("uat");
        },
        "data-sentry-element": "RadioPill",
        "data-sentry-source-file": "IcertisConfigureScreen.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(RadioDot, {
          $selected: envTier === "uat",
          "data-sentry-element": "RadioDot",
          "data-sentry-source-file": "IcertisConfigureScreen.tsx"
        }), "UAT"]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(HelperText, {
      "data-sentry-element": "HelperText",
      "data-sentry-source-file": "IcertisConfigureScreen.tsx",
      children: "If UAT is not selected, you will be logged into the Production environment."
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonsWrapper, {
      "data-sentry-element": "ButtonsWrapper",
      "data-sentry-source-file": "IcertisConfigureScreen.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(LoginButton, {
        onClick: onLogin,
        disabled: region === null,
        "data-sentry-element": "LoginButton",
        "data-sentry-source-file": "IcertisConfigureScreen.tsx",
        children: "Login"
      })
    })]
  });
};
var _default = exports.default = IcertisConfigureScreen;